import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-mall-media",
  "use": "icon-soc-l1-mall-media-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-mall-media\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M192 256h640v512H192V256zm64 64v384h512V320H256zm96 96l288 128-288 128V416z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-mall-media.svg
// module id = 6AF7
// module chunks = 534